module.exports = __webpack_public_path__ + "img/Butterfly_00359.43130bfa.png";